import React from 'react';
import { format } from 'date-fns';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import { STORE_IMAGES } from '../../constants/urls';
import { DEFAULT_BUTTON_COLOR } from '../../styles/Variables';
import { normalizeColor } from '../../utils/Coupons/colors';
import OnlineOffer from './OnlineOffer';
import * as S from './Styled';

export const formatCashback = (value) =>
    `+${Number(value).toLocaleString('pt-BR', { maximumFractionDigits: 1 })}%`;

// Áreas LOYALTY dão o dobro do cashback da loja
export const getCashbackPercentage = (store, categorie) => {
    if (!store?.cashbackOn || !(store?.cashbackPercentage > 0)) return null;
    return categorie?.type === 'LOYALTY' ? store.cashbackPercentage * 2 : store.cashbackPercentage;
};

const CouponCard = ({
    id,
    coupon,
    categorie = {},
    uppercaseTitle = false,
    isAuthenticated,
    openCoupon,
    getcouponRedirect,
    utmSource,
    utmCampaign,
    userId,
    incentiveId,
    slug,
    showAlert,
}) => {
    if (!coupon?.store) return null;

    const buttonColor = normalizeColor(categorie?.buttonColor, DEFAULT_BUTTON_COLOR);
    const cashback = getCashbackPercentage(coupon.store, categorie);
    const endDate = coupon.endDate ? format(new Date(coupon.endDate), 'dd/MM/yyyy') : null;

    return (
        <S.Card id={id}>
            <S.CardLogo
                src={`${STORE_IMAGES}${coupon.store.slug || 'default'}.png`}
                alt={coupon.store.name || ''}
            />

            {cashback && (
                <S.CashbackChip>
                    {formatCashback(cashback)} de cashback
                </S.CashbackChip>
            )}

            <S.CardTitle $uppercase={uppercaseTitle} title={coupon.name}>
                {coupon.name}
            </S.CardTitle>
            {coupon.description && <S.CardDescription>{coupon.description}</S.CardDescription>}

            {endDate && (
                <S.CardMeta>
                    <AccessAlarmIcon sx={{ fontSize: '0.9rem' }} />
                    Válido até {endDate}
                </S.CardMeta>
            )}

            <S.CardAction>
                <S.BotaoCupom>
                    <OnlineOffer
                        type={coupon.type}
                        isAuthenticated={isAuthenticated}
                        coupon={coupon}
                        categorie={categorie}
                        openModal={openCoupon}
                        buttonColor={buttonColor}
                        getcouponRedirect={getcouponRedirect}
                        utmSource={utmSource}
                        utmCampaign={utmCampaign}
                        userId={userId}
                        incentiveId={incentiveId}
                        slug={slug}
                        showAlert={showAlert}
                    />
                </S.BotaoCupom>
            </S.CardAction>
        </S.Card>
    );
};

export default CouponCard;
